export function supCharacter(content, find = ['®']) {
    let replaceString = content;
    for (let i = 0; i < find.length; i++) {
        replaceString = replaceString.replace(find[i], `<sup>${find[i]}</sup>`);
    }
    return replaceString;
}



// WEBPACK FOOTER //
// ./src/filter/supCharacter.js